module.exports = __webpack_public_path__ + "static/media/logo-without-label2.1a5dc3ec.png";